import Cookies from 'js-cookie'
import { create } from 'zustand'
import { clearPlanCache } from '@/lib/plan-cache'

const ACCESS_TOKEN = 'bearer_token'
const USER_INFO = 'user_info'

export type AccountRoles = 'FREE' | 'PLUS' | 'PRO' | 'ENTERPRISE'

interface AuthUser {
  id: string
  email: string
  name: string
  last_name: string
  mobile_phone?: string | null
  role_id: string
  organization_id: string | null
  role: string
}

interface AuthState {
  auth: {
    user: AuthUser | null
    setUser: (user: AuthUser | null) => void
    getUser: () => AuthUser | null
    getUserRole: () => AccountRoles | null
    accessToken: string
    setAccessToken: (accessToken: string) => void
    resetAccessToken: () => void
    reset: () => void
    isAuthenticated: () => boolean
  }
}

export const useAuthStore = create<AuthState>()((set) => {
  const cookieState = Cookies.get(ACCESS_TOKEN)
  const initToken = cookieState ? JSON.parse(cookieState) : ''

  const userCookie = Cookies.get(USER_INFO)
  const initUser = userCookie ? JSON.parse(userCookie) : null

  return {
    auth: {
      isAuthenticated: () => {
        const cookieState = Cookies.get(ACCESS_TOKEN)
        return cookieState ? JSON.parse(cookieState) !== '' : false
      },
      user: initUser,
      setUser: (user) =>
        set(
          (state) => (
            Cookies.set(USER_INFO, JSON.stringify(user)),
            { ...state, auth: { ...state.auth, user } }
          )
        ),
      getUser: () => {
        const userInfo = Cookies.get(USER_INFO)
        return userInfo ? JSON.parse(userInfo) : null
      },
      getUserRole: () => {
        const userInfo = Cookies.get(USER_INFO)
        if (!userInfo) return null
        const user = JSON.parse(userInfo)
        const role = user?.role

        return role || null
      },
      accessToken: initToken,
      setAccessToken: (accessToken) =>
        set((state) => {
          Cookies.set(ACCESS_TOKEN, JSON.stringify(accessToken))
          return { ...state, auth: { ...state.auth, accessToken } }
        }),
      resetAccessToken: () =>
        set((state) => {
          Cookies.remove(ACCESS_TOKEN)
          return { ...state, auth: { ...state.auth, accessToken: '' } }
        }),
      reset: () =>
        set((state) => {
          Cookies.remove(ACCESS_TOKEN)
          Cookies.remove(USER_INFO)
          clearPlanCache()
          return {
            ...state,
            auth: { ...state.auth, user: null, accessToken: '' },
          }
        }),
    },
  }
})

// export const useAuth = () => useAuthStore((state) => state.auth)
